import React, { useState } from 'react';
import { Tabs, Tab, Box,CssBaseline,Container } from '@mui/material';
import CategoryManagement from './CategoryManagement';
import Products from './Products';
import { ThemeProvider } from "@mui/material/styles";
import theme from "./theme";
import Layout from "./Layout";
import { useAppContext } from './AppContext';

const ProductManagement = () => {
  const [tabValue, setTabValue] = useState(0);
  const [categories, setCategories] = useState([
    { id: 1, name: 'Cakes' },
    { id: 2, name: 'Ice Cream' },
  ]);
  const { t } = useAppContext();

  
  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const handleCategoryUpdate = (updatedCategories) => {
    setCategories(updatedCategories);
    console.log(updatedCategories);
  };

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Layout>
    <Container>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={tabValue} onChange={handleTabChange} aria-label={t("Product and category management tabs")}>
          <Tab label={t("Products")} />
          <Tab label={t("Categories")} />
        </Tabs>
      </Box>
      <Box mt={3}>
        {tabValue === 0 && <Products categories={categories} onCategoryUpdate={handleCategoryUpdate} />}
        {tabValue === 1 && <CategoryManagement categories={categories} onCategoryUpdate={handleCategoryUpdate} />}
      </Box>
    </Container>
    </Layout>
    </ThemeProvider>
  );
};

export default ProductManagement;
